import { cn } from '@/shared/lib/cn'

interface HeartbeatLineProps {
  /** Dentro do card de marca no login — sem borda/fundo próprios. */
  embedded?: boolean
}

export const HeartbeatLine = ({ embedded = false }: HeartbeatLineProps) => (
  <div
    className={cn(
      'relative w-full overflow-hidden',
      embedded
        ? 'px-1 pt-1'
        : 'rounded-2xl border border-[var(--color-border)] bg-white/88 px-2 py-3',
    )}
  >
    <svg
      viewBox="0 0 240 60"
      className={cn('w-full', embedded ? 'h-10' : 'h-14')}
      preserveAspectRatio="none"
      aria-hidden
    >
      <path
        className="synap-ecg-track"
        d="M0 30H14L20 29L28 30L36 30L44 29L52 30H60L68 24L74 35L81 29L88 30H98L106 30L112 24L118 40L125 26L132 30H142L150 29L158 30L166 30L174 27L182 35L190 30H202L210 29L218 30L226 30H240"
      />
      <path
        className="synap-ecg-wave"
        d="M0 30H14L20 29L28 30L36 30L44 29L52 30H60L68 24L74 35L81 29L88 30H98L106 30L112 24L118 40L125 26L132 30H142L150 29L158 30L166 30L174 27L182 35L190 30H202L210 29L218 30L226 30H240"
      />
    </svg>
  </div>
)
